module.exports = __webpack_public_path__ + "img/banner.63fd76f2.png";